import { render } from "./PlayerTrajectory.vue?vue&type=template&id=62a58bf5"
import script from "./PlayerTrajectory.vue?vue&type=script&lang=js"
export * from "./PlayerTrajectory.vue?vue&type=script&lang=js"
script.render = render

export default script